import * as commonActions from '../actions/common.actions';
import * as _ from 'lodash';
import {createSelector} from '@ngrx/store';

export interface State {
    itemList: any[],
    partyList: any[],
    companyList: any[],
    auth: any[]
}

export const INIT_SKU_STATE: State = {
    itemList: [],
    partyList: [],
    companyList: [],
    auth: []
};

export function reducer(state: State = INIT_SKU_STATE, action: commonActions.All) {

    switch (action.type) {
        case commonActions.IS_AUTH_SUCCESS: {
            return Object.assign(
                {},
                state,
                { auth: action.payload }
            )
        }
        case commonActions.LOAD_ALL_ITEM_SUCCESS: {
            return Object.assign(
                {},
                state,
                { itemList: action.payload }
            )
        }
        case commonActions.LOAD_ALL_PARTY_SUCCESS: {
            return Object.assign(
                {},
                state,
                { partyList: action.payload }
            )
        }
        case commonActions.LOAD_ALL_COMPANY_SUCCESS: {
            return Object.assign(
                {},
                state,
                { companyList: action.payload }
            )
        }
    
        default: {
            return state;
        }
    }
}


// SELECTORS (all selectors must be pure functions)
export const getAuth = (state: State): any[] => state.auth;
export const getAllItem = (state: State): any[] => state.itemList;
export const getAllParty = (state: State): any[] => state.partyList;
export const getAllCompany = (state: State): any[] => state.companyList;



// WEBPACK FOOTER //
// /Users/afsarahamed/Documents/symatis/projects/hyatt-angularweb/src/app/store/reducers/common.reducer.ts